import { __extends } from "tslib";
import { CreateAppRequest, CreateAppResponse } from "../models/models_0";
import { deserializeAws_restJson1CreateAppCommand, serializeAws_restJson1CreateAppCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateAppCommand = /** @class */ (function (_super) {
    __extends(CreateAppCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateAppCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateAppCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "CreateAppCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateAppRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateAppResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateAppCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1CreateAppCommand(input, context);
    };
    CreateAppCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1CreateAppCommand(output, context);
    };
    return CreateAppCommand;
}($Command));
export { CreateAppCommand };
//# sourceMappingURL=CreateAppCommand.js.map